export function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function applyReducedMotionVideos(root = document) {
  if (!prefersReducedMotion()) return;

  root.querySelectorAll('video[data-autoplay="true"], video[autoplay]').forEach((video) => {
    video.removeAttribute("autoplay");
    video.pause();

    if (!video.hasAttribute("controls")) {
      video.setAttribute("controls", "");
    }
  });
}
